import { render, staticRenderFns } from "./oss.vue?vue&type=template&id=27467b81&"
import script from "./oss.vue?vue&type=script&lang=js&"
export * from "./oss.vue?vue&type=script&lang=js&"
import style0 from "./oss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports